import React, { Component } from 'react';

import {
    Container,
	Row,
	Col,
	} from 'reactstrap';
import API from '../API';
import { Modal, ModalOpen } from '../Modal';
import { AUAContainer } from '../AUA';
import { T } from '../traks';
import { current_site_id } from '../Site';
import Butt from './Butt';
import SubscriptionDurationSelector from './SubscriptionDuration';

function PremiumInit() {
	ModalOpen("PremiumModal");
}

class PremiumInnerContent extends Component {
    constructor(props) {
		super(props);

        const { aua } = this.props;

        this.state = {
            customer_type: aua.me && aua.me.CustomerType ? aua.me.CustomerType.String : '',
            screen_name: aua.me && aua.me.ScreenName ? aua.me.ScreenName : '',
			email: aua.me && aua.me.LocalEmail ? aua.me.LocalEmail : '',
            phone: "",
            subscription_duration: "",
            amount_invites: 10,
            err_email_missing: false,
			is_submitted: false,
			is_submitted_err: false
        }
	}
    
    

    render() {
        const input_classname = (more, has_error) => {
            var c = "form-control p-3 ad_signuplogin_input ";
            if (more) c += more;
            if (has_error) c += " ad_input_error";
            return c;
        };

        const validate_and_post = (e) => {
			e.preventDefault();

			if (validate(e)) {
				return;
			}
	
			// Simulate an API call with callback
			API.post(
				"/z/send_premium_request",
				{
					customer_type: this.state.customer_type,
					name: this.state.screen_name,
					email: this.state.email,
					phone: this.state.phone,
                    subscription_duration: this.state.subscription_duration,
                    amount_invites: this.state.amount_invites, 
					site: current_site_id,
					lang: this.props.lang,
				},
				(response, status) => {
					if (status === 200) {
						this.setState({ is_submitted: true });
					} else {
						this.setState({ is_submitted_err: true });
					}
				}
			);
		};

        const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

        const validate = (e) => {
			e.preventDefault();
	
			// Reset error states before validation
			var new_state = {
				err_email_missing: false,
			};
	
			// Validate the form fields	
			if (this.state.email.trim().length === 0) {
				new_state.err_email_missing = true;
			}
	
			// Check if there are any errors
			const has_errors = () => {
				return (
					new_state.err_email_missing
				);
			};

            if (has_errors()) {
				this.setState(new_state);
				return;
			}

            return has_errors()
		};

        const getUrlByLang = () => {
            const lang = this.props.lang;
            if (lang === 'da') {
                return 'https://undervisning.aktiedysten.dk/ny-mulighed-kommer-snart/';
            } else if (lang === 'sv') {
                return 'https://undervisning.aktiekampen.se/uppgradera-ditt-spel/';
            } else if (lang === 'de') {
                return 'https://bildung.investspiel.de/ruste-dein-spiel/';
            } else {
                return 'https://undervisning.aktiedysten.dk/premium-games/'
            }
        }

        const InputHeader = (props) => {
			var insert_text;
			const err = props.err || [];
			var classes;
			for (const [field, text] of err)  {
				if (this.state[field]) {
					insert_text = text;
					classes = "errors";
					break;
				}
			}

			if (!insert_text) {
				const txt = props.txt || [];
				for (const [field, text] of txt) {
					if (this.state[field]) {
						insert_text = text;
						classes = "ad_signuplogin_input_header";
						break;
					}
				}
			}

			if (!insert_text) {
				insert_text = "WOOP";
				classes = "ad_signuplogin_input_header ad_invisible";
			}

			return <div className={classes}>{insert_text}</div>;
		};

        const type_value = this.state.customer_type;
        const screen_name_value = this.state.screen_name;
		const email_value = this.state.email;
        const phone_value = this.state.phone;
        const subscription_duration_value = this.state.subscription_duration;
        const amount_invites_value = this.state.amount_invites;
        const state_err_email_missing = this.state.err_email_missing;
        const state_err_invalid_email = this.state.err_invalid_email;
		const state_is_submitted = this.state.is_submitted;
		const state_is_submitted_err = this.state.is_submitted_err

		return (
			<Row>
				<Col md={5} className="ad_signuplogin_lcol">
					<div className="ad_signuplogin_header px-4 pt-5 pb-3">
						<T>Buy access to create premium games</T>
					</div>
                    <p className='pl-4 pr-5 ad_signuplogin_text'>
                        <T>You are now purchasing a premium subscription for your profile. Choose here on the right how many invitations you want to open up. That is how many would you like to be able to play with on your premium games</T>
                    </p>
					<Container className="pr-5 ad_signuplogin_text">
						<Row className="pl-3 py-4">
							<Col md={2}>
								<img alt="money_icon" src="/gfx/money-switch-0.svg" className="ad_34px" />
							</Col>
							<Col>
								<T>Access BETA values on all assets included in the stock game, with leaderboard ranking.</T>
							</Col>
						</Row>
		
						<Row className="pl-3 py-4">
							<Col md={2}>
								<img alt="compete_icon" src="/gfx/award-0.svg" className="ad_34px" />
							</Col>
							<Col>
								<T>Industry indicators and detailed descriptions for companies.</T>
							</Col>
						</Row>
		
						<Row className="pl-3 py-4">
							<Col md={2}>
								<img alt="security_icon" src="/gfx/security-0.svg" className="ad_34px" />
							</Col>
							<Col>
								<T>Expanded asset options including bonds, funds, indices, and commodities like gold, aluminum, silver, wheat, and oil.</T>
							</Col>
						</Row>

                        <Row className="pl-3 py-4">
							<Col md={2}>
								<img alt="bankroll" src="/gfx/bankroll-icon-color-0.svg" className="ad_34px" />
							</Col>
							<Col>
								<T>Prices from 12 to 24 DKK for each key per month. <a href={getUrlByLang()} target="_blank" rel="noopener noreferrer" className="ad_signuplogin_action">See our plans here</a></T>
							</Col>
						</Row>
		
						<Row className="pt-4 pb-5">
							<Col>
								<T>*Minimum 10 users</T>
							</Col>
						</Row>
					</Container>
				</Col>
				
				<Col md={7} className="ad_signuplogin_rcol">
					<div className="mx-sm-5 mt-5">
						{state_is_submitted ? (
							<div className="text-center py-5">
								<p><b><T>Thank you for your purchase. We are now starting to move you to a premium subscription</T></b></p>
                                <p><T>We will contact you on your email, where you will receive a welcome PDF with all the practical information about your premium subscription and invoice.</T></p>
                                <p><T>If you have any questions, please contact us at <a className='login_text_notloggedin' href="mailto:info@aktiedysten.dk">info@aktiedysten.dk</a></T></p>
							</div>
						) : (
                            <div>
                            {state_is_submitted_err && (
                                <div className="text-center py-5">
								    <p><T>An error occurred during registration, please try again.</T></p>
							    </div>
                            )}

							<form onSubmit={validate_and_post}>
                                <Row className='mb-4'>
									<Col>
										<SubscriptionDurationSelector duration={subscription_duration_value} onChange={(e) => change(e)}  />
									</Col>
								</Row>
                                <Row>
                                    <Col>
										<T><InputHeader txt={[["amount_invites", "Amount of invites"]]} /></T>
										<T><input
											placeholder="Amount of invites"
											className={input_classname("mb-4")}
											type="number"
											name="amount_invites"
											value={amount_invites_value}
                                            min={10}
											onChange={change}
                                            onBlur={validate}
										/></T>
									</Col>
                                </Row>
								<Row>
									<Col>
										<T><InputHeader
											txt={[["email", "Email"]]}
											err={[
												["err_email_missing", "You must enter an email"],
												["err_invalid_email", "The email is invalid"],
											]}
										/></T>
										<T><input
											placeholder="Email"
											className={input_classname("mb-4", state_err_email_missing || state_err_invalid_email)}
											type="email"
											name="email"
											value={email_value}
											onChange={change}
                                            onBlur={validate}
										/></T>
									</Col>
								</Row>
								<Row>
									<Col>
										<T><InputHeader txt={[["phone", "Phone number"]]} /></T>
										<T><input
											placeholder="Phone (optional)"
											className={input_classname("mb-4")}
											type="tel"
											name="phone"
											value={phone_value}
											onChange={change}
                                            onBlur={validate}
										/></T>
									</Col>
								</Row>
                                <input type='hidden' name="customer_type" value={type_value} />
                                <input type='hidden' name="screen_name" value={screen_name_value} />
								<Butt className="ad_rbtn w-100 ad_signuplogin_btn px-5 py-3 mb-5" type="submit">
									<T>Order</T>
								</Butt>
							</form>
                            </div>
						)}
					</div>
				</Col>
			</Row>
		);
    }
}

const PremiumInner = (props) => <AUAContainer><PremiumInnerContent {...props}/></AUAContainer>;

class PremiumModal extends Modal {
    allow_close_via_ui() {
		return true;
	}

	mrender() {
		return <PremiumInner {...this.props}/>;
	}

	get_name() {
		return "PremiumModal";
	}

	get_fullscreen_bg_class() {
		return "ad_signuplogin_dark";
	}

	get_bootstrap_modal_class() {
		return "ad_signuplogin_modal_lg";
	}
}

export {
	PremiumModal,
	PremiumInit,
};



// WEBPACK FOOTER //
// ./src/c/PremiumModal.js